import React from "react";
import SuppliersInvoicesModal from "../../Layout/SuppliersInvoicesModal";
import {
  exportSuppliersInvoice,
  parseSuppliersInvoice
} from "../../../redux/Actions/suppliersInvoicesAction";
import { connect } from "react-redux";
import TableItem from "./TableItem";
import StoreEdit from "./StoreEdit";

class ManagersEditModal extends React.Component {
  constructor() {
    super();
    this.state = {
      action: "edit",
      preview_manager: false,
      preview_sales: true,
      loading: false,
      invoice: {
        suppliers_invoices_items: []
      },
      month: new Date().getMonth() + 1,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (Object.keys(nextProps.objectData).length > 0) {
      const data = nextProps.objectData;

      this.setState({
        invoice: data,
        action: "edit",
      });
    }
  }

  exportInvoice = () => {
    let id = this.state.invoice.id;
    this.setState({
      loading: true
    });
    this.props.exportSuppliersInvoice(id).then((res) => {
      this.setState({
        loading: false
      });
    });
  };

  parseInvoice = (documentType = null) => {
    let id = this.state.invoice.id;
    this.setState({
      loading: true
    });
    this.props.parseSuppliersInvoice(id, documentType).then((res) => {
      this.setState({
        loading: false
      });
    });
  };

  render() {
    return (
      <SuppliersInvoicesModal
        status="tableEdit"
        text={this.state.invoice.invoice_number}
        exported={this.state.invoice.exported}
        suppliers_invoices_document_id={this.state.invoice.suppliers_invoices_document_id}
        regex_parse={this.state.invoice.regex_parse}
        suppliers_invoice_download_url={this.state.invoice.suppliers_invoice_download_url}
        id={this.state.invoice.id}
        pay_due={this.state.invoice.pay_due_date}
        invoice_date={this.state.invoice.invoice_date}
        exportInvoice={() => this.exportInvoice()}
        parseInvoice={(parseMode) => this.parseInvoice(parseMode)}
        supplier={this.state.invoice.supplier_name}
        sales_number={this.state.invoice.sales_number}
        delivery_address={this.state.invoice.delivery_address}
        supplier_id={this.state.invoice.supplier_id}
        loading={this.state.loading}
        transport_price={this.state.transport_price}
        supplier_invoice_items={this.state.invoice.suppliers_invoices_items}
        store={<StoreEdit id={this.state.invoice.id} store={this.state.invoice.store} stores={this.props.stores} />}
      >
        <div className="row">
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table table-sm table-hover mt-3">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">Number</th>
                    <th className="text-black">Rivile code</th>
                    <th className="text-black">Supplier code</th>
                    <th className="text-black">MPN</th>
                    <th className="text-black">EAN</th>
                    <th className="text-black">Barcode</th>
                    <th className="text-black">Title</th>
                    <th className="text-black">Quantity</th>
                    <th className="text-black">Price per unit</th>
                    <th className="text-black">Agata code</th>
                    <th className="text-black">Agata Sum</th>
                    <th className="text-black">Sum</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.invoice.suppliers_invoices_items && this.state.invoice.suppliers_invoices_items.map((item, index) => (
                    <TableItem key={index} index={index} id={item.id} item={item} />
                  ))}
                </tbody>
              </table>
              <div className="d-flex justify-content-end">
                <p className="mt-2 mr-4 mt-2">
                  <span
                    className="text-black mr-3"
                    style={{ fontSize: "14px" }}
                  >
                    <b>Quantity of goods:</b> {this.state.invoice.items_quantity}
                  </span>
                  <span className="text-black" style={{ fontSize: "14px" }}>
                    <b>Amount without VAT:</b> {this.state.invoice.price_without_pvm}
                  </span>
                </p>
                <p className=" mt-2 mr-4 mt-2">
                  <span
                    className="text-black mr-3"
                    style={{ fontSize: "14px" }}
                  >
                    <b>VAT:</b> {this.state.invoice.pvm}
                  </span>
                  <span className="text-black mr-3" style={{ fontSize: "14px" }}>
                    <b>Discount:</b> {this.state.invoice.discount}
                  </span>
                  <span className="text-black mr-3" style={{ fontSize: "14px" }}>
                    <b>Transport:</b> {this.state.invoice.transport_price}
                  </span>
                  <span className="text-black" style={{ fontSize: "14px" }}>
                    <b>Final amount:</b> {this.state.invoice.price_total}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </SuppliersInvoicesModal>
    );
  }
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {
  exportSuppliersInvoice,
  parseSuppliersInvoice
})(ManagersEditModal);
